// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.credit-card-icon[data-v-3c5f7040] {\n  position: relative;\n  /* background-color: white; */\n  overflow: hidden;\n  border-radius: 4px;\n  height: 35px;\n  width: 50px;\n  min-width: 50px;\n}\n.credit-card-icon img[data-v-3c5f7040] {\n  width: 50px;\n  height: auto;\n  background-color: white;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
